import {
  addNavMenuItem,
  addNavMenuSection,
  PageLocationId,
  registerPageTab,
} from "@bb-vendure/admin-ui/core";
import NotiCampaignsComponent from "./push-notification/list/list.components";
import PushTemplateListComponent from "./push-template/list/list.component";

export default [
  addNavMenuSection(
    {
      id: "notifications",
      label: "push.notification",
      items: [
        {
          id: "push-notifications",
          label: "push.push-template",
          routerLink: ["/push-template"],
          icon: "bell",
        },
      ],
    },
    "purchase-request"
  ),

  registerPageTab({
    location: "notification-template-list" as PageLocationId,
    tab: "push.push-template",
    route: "/push-template",
    tabIcon: "bell",
    component: PushTemplateListComponent,
  }),

  registerPageTab({
    location: "notification-history" as PageLocationId,
    tab: "push.notification",
    route: "/push-notifications",
    tabIcon: "bell",
    component: NotiCampaignsComponent,
  }),

  // addNavMenuItem(
  //   {
  //     id: "push-notifications",
  //     label: "push.notification",
  //     routerLink: ["/push-notifications"],
  //     icon: "bell",
  //   },
  //   "marketing"
  // ),
];
